import { useState } from 'react';
// mantine
import { Combobox, InputBase, useCombobox } from '@mantine/core';
// components
import VoiceOption from '@/pages/Settings/components/Voice/components/VoiceSelect/components/VoiceOption';
import { TVoiceOption } from '@/pages/Settings/components/Voice/Voice.types';

interface VoiceSelectProps {
    voiceId: string;
    onChange: (voiceId: string) => void;
    options: TVoiceOption[];
}

const VoiceSelect = ({ voiceId, onChange, options }: VoiceSelectProps) => {
    const [activeVoiceId, setActiveVoiceId] = useState<string | undefined>();
    const combobox = useCombobox({
        onDropdownClose: () => {
            setActiveVoiceId(undefined);
            combobox.resetSelectedOption();
        }
    });

    const voice = options.find((option) => option.voice_id === voiceId);

    const handlePlayToggle = (vId?: string) => {
        setActiveVoiceId(voiceId && activeVoiceId !== vId ? vId : undefined);
    };

    return (
        <div className="flex flex-col gap-1">
            <div className="text-xs font-semibold">Select voice</div>
            <Combobox
                store={combobox}
                onOptionSubmit={(value) => {
                    onChange(value);
                    combobox.closeDropdown();
                }}
            >
                <Combobox.Target>
                    <InputBase
                        pointer
                        component="button"
                        rightSection={<Combobox.Chevron />}
                        rightSectionPointerEvents="none"
                        type="button"
                        onClick={() => {
                            combobox.toggleDropdown();
                        }}
                    >
                        {voice ? voice.name : 'Select voice'}
                    </InputBase>
                </Combobox.Target>

                <Combobox.Dropdown>
                    <Combobox.Options className="overflow-auto" mah={300}>
                        {options.map((option) => (
                            <Combobox.Option
                                key={option.voice_id}
                                value={option.voice_id}
                            >
                                <VoiceOption
                                    isActive={activeVoiceId === option.voice_id}
                                    voice={option}
                                    onPlayToggle={handlePlayToggle}
                                />
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                </Combobox.Dropdown>
            </Combobox>
        </div>
    );
};

export default VoiceSelect;
